import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { Observable } from 'rxjs';

/**
 * Reusable search option component for course selection dropdowns
 * Extracts duplicated search input block to reduce template duplication
 * Handles: search input, filtering, status messages, add course dialog
 */
@Component({
  selector: 'app-course-search-option',
  templateUrl: './course-search-option.component.html',
  styleUrls: ['./course-search-option.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, MatInputModule],
})
export class CourseSearchOptionComponent {
  @Input() course: any;
  @Input() selectRef: any;
  @Input() searchInputId: string = '';
  @Input() filteredOptions$: Observable<string[]> | null = null;
  @Input() statusMessage: string = '';
  @Input() courseSearchText: string = '';
  @Input() addingCourse: boolean = false;
  @Input() MESSAGES: any = {};

  @Output() searchInputChange = new EventEmitter<string>();
  @Output() searchInput = new EventEmitter<void>();
  @Output() searchEnter = new EventEmitter<KeyboardEvent>();
  @Output() stopPropagation = new EventEmitter<MouseEvent>();
  @Output() keydownSpace = new EventEmitter<KeyboardEvent>();
  @Output() addCourse = new EventEmitter<{ course: any; selectRef: any; event: MouseEvent }>();

  onSearchInputChange(value: string): void {
    this.courseSearchText = value;
    this.searchInputChange.emit(value);
    this.onSearchInput();
  }

  onSearchInput(): void {
    this.searchInput.emit();
  }

  onSearchEnter(event: KeyboardEvent): void {
    this.searchEnter.emit(event);
  }

  onStopPropagation(event: MouseEvent): void {
    event.stopPropagation();
    this.stopPropagation.emit(event);
  }

  onKeydownSpace(event: KeyboardEvent): void {
    event.stopPropagation();
    this.keydownSpace.emit(event);
  }

  onAddCourse(event: MouseEvent): void {
    this.addCourse.emit({ course: this.course, selectRef: this.selectRef, event });
  }
}
